import React from "react";
import Formnav from "./FormNav";
import Formfooter from "./FormFooter";
import ForgetPasswordForm from "./ForgetPasswordForm";
import { Constants } from "../../CommonMethhods/Constants";
import ForgetTelePasswordForm from "./ForgetTelePasswordForm";

function ForgetTelecallerPassword() {
  return (
    <>
      <title>{Constants.Forget_Password}</title>
      <div className="login-page">
        <div className="login-content h-100">
          <div className="container h-100">
            <div className="row h-100">
              {/* <Formnav /> */}
              <div className="ipad-bottom m-auto">
                <ForgetTelePasswordForm />
                <Formfooter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgetTelecallerPassword;
